function calcWithPrecision(sum, precision) {
  let ar = (precision = Math.pow(10, precision));
  return Math.round(sum * ar) / ar;
}

export default calcWithPrecision;
